module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAARCAYAAADDjbwNAAAAbElEQVR42mNUkDGp/8/A2MBAZfCfgbHh0ZNTjTA+o7yM6X8GGoGHT04zwthMjAz/G2lhyX8GxkaGUTCkACOtkjd6Uqdp8kYGzIJ8UowMDIwONPbRaFIf7skbvYTGaxGlyRu5hMYHKCq9SUm2ABylI2zLA+36AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/Navbar/burger.png
// module id = 120
// module chunks = 51